import { goSolidApi } from "@/composables/useGoSolidApi";
import { useGlobalHandlers } from "@/composables/useGlobalHandlers";
import { ref } from "vue";

export interface SwapReferrerOption {
  value: number;
  label: string;
}

export function useSwapReferrers() {
  const { globalErrorHandler } = useGlobalHandlers();
  const options = ref<SwapReferrerOption[]>([]);

  const fetchCandidates = async () => {
    try {
      const response = await goSolidApi.get(
        "/api/admin/commission/swap-referrer-candidates"
      );
      options.value = (response.data?.data ?? []).map(
        (c: {
          id: number;
          name: string | null;
          registry_code: string | null;
        }) => ({
          value: c.id,
          label: c.registry_code
            ? `${c.name ?? `#${c.id}`} (${c.registry_code})`
            : (c.name ?? `#${c.id}`),
        })
      );
    } catch (error) {
      globalErrorHandler(error);
    }
  };

  return { options, fetchCandidates };
}
